// INTL TEL INPUT
// ------------------------------------------------------------------
/* yarn add intl-tel-input */
/* import intlTelInput from "intl-tel-input"
window.intlTelInput = intlTelInput */

// ISOTOPE
// ------------------------------------------------------------
/* yarn add jquery-bridget */
/* yarn add isotope-layout */
/* var jQueryBridget = require('jquery-bridget')
var Isotope = require('isotope-layout')
jQueryBridget('isotope', Isotope, $) */

// COOKIE
// ------------------------------------------------------------
/* yarn add js-cookie */
/* import Cookies from 'js-cookie' */

// Tippy
// ----------------------------------------------------------- 
import tippy from 'tippy.js'
// TIPPY - TOOLTIP
// ------------------------------------------------------------
tippy(".main-tooltip", {
    allowHTML: true,
    placement: "top",
    arrow: true,
    animation: "perspective",
    theme: "penta",
})

// MEGA MENU
// ------------------------------------------------------------------
if ($('.has-mega-menu').length) {
    let hasMegaMenu = $('.has-mega-menu')
    let megaMenuItem = $('.has-mega-menu .mega-menu-container .mega-menu .wrapper .right-field')
    megaMenuItem.height(megaMenuItem.find('.mm-item.active').height())
    let megaMenuLi = $('.has-mega-menu .mega-menu-container .mega-menu .wrapper .left-field .mm-ul .mm-li')
    let megaMenuItemField = megaMenuItem.find('.mm-item')
    let megaMenuLiID, megaMenuItemID
    megaMenuLi.hover(
        function () {
            megaMenuLi.removeClass('active')
            $(this).addClass('active')
            megaMenuLiID = $(this).attr('data-id')
            megaMenuItemField.removeClass('active')
            $.each(megaMenuItemField, function () {
                megaMenuItemID = $(this).attr('data-id')
                if (megaMenuLiID == megaMenuItemID) {
                    $(this).addClass('active')
                }
            })
        },
        function () { }
    )
    if (windowWidth > 1200) {
        hasMegaMenu.hover(
            function () {
                $('header').addClass('light')
            },
            function () {
                $('header').removeClass('light')
            }
        )
    }
}
// SUB MENU
// ------------------------------------------------------------------
if ($('.has-sub-menu').length) {
    let hasSubMenu = $('.has-sub-menu')
    if (windowWidth > 1200) {
        hasSubMenu.hover(
            function () {
                $('header').addClass('light')
            },
            function () {
                $('header').removeClass('light')
            }
        )
    }
}


// MOBILE MENU
// ------------------------------------------------------------------
if ($('.mobile-menu-selector').length) {
    if (windowWidth <= 1200) {
        let mobileMenuSelector = $('.mobile-menu-selector')
        let mobileMenu = $('.menu-field .menu .menu-ul')
        let subMenuSelector = $('.has-sub-menu')
        let megaMenuSelector = $('.has-mega-menu')
        mobileMenu.addClass('scrollbar')
        mobileMenuSelector.click(function () {
            mobileMenu.stop(true, true).slideToggle(450)
            $(this).toggleClass('active')
            $('header').toggleClass('light')
            $('body').toggleClass('overflow-hidden')
            $('.bg-overlay').toggleClass('active')
        })
        subMenuSelector.click(function () {
            $(this).find('.sub-menu').stop(true, true).slideToggle(450)
        })
        megaMenuSelector.click(function () {
            $(this).find('.mega-menu-container').stop(true, true).slideToggle(450)
        })
        $('.bg-overlay').click(function () {
            mobileMenuSelector.removeClass('active')
            $('header').removeClass('light')
            $('body').removeClass('overflow-hidden')
            $('.bg-overlay').removeClass('active')
            mobileMenu.stop(true, true).slideUp(450)
            subMenuSelector.find('.sub-menu').stop(true, true).slideUp(450)
            megaMenuSelector.find('.mega-menu-container').stop(true, true).slideUp(450)
        })

        let megaMenuItem = $('.has-mega-menu .mega-menu-container .mega-menu .wrapper .right-field')
        let megaMenuItemField = megaMenuItem.find('.mm-item')
        let megaMenuLi = $('.has-mega-menu .mega-menu-container .mega-menu .wrapper .left-field .mm-ul .mm-li')
        let megaMenuLiID, megaMenuItemID, megaMenuThis

        if (windowWidth <= 1200) {
            $.each(megaMenuLi, function () {
                megaMenuThis = $(this)
                megaMenuLiID = $(this).attr('data-id')
                $.each(megaMenuItemField, function () {
                    megaMenuItemID = $(this).attr('data-id')
                    if (megaMenuLiID == megaMenuItemID) {
                        megaMenuThis.append($(this))
                    }
                })
            })
        }
    }
    let otherMenuButton = $('.other-menu-button')
    let otherMenuLanguage = $('.other-menu-language')
    let menuField = $('.menu-field .menu .menu-ul')
    let otherMenuUL = $('.other-menu-field ul')
    if (windowWidth <= 768) {
        menuField.append(otherMenuButton)
    }
    if (windowWidth <= 425) {
        menuField.append(otherMenuLanguage)
    }

    $(window).resize(function () {
        let windowWidthResize = window.innerWidth
        if (windowWidthResize <= 768) {
            menuField.append(otherMenuButton)
        }
        if (windowWidthResize <= 425) {
            menuField.append(otherMenuLanguage)
        }
    })
}

// BREADCRUMB
// ------------------------------------------------------------------
if ($('.breadcrumb').length) {
    let breadcrumbTextWrapper = $('.breadcrumb .container .wrapper .image-field .text-container .text-wrapper')
    let breadcrumbIMG = $('.breadcrumb .container .wrapper .image-field .img')
    if (windowWidth <= 600) {
        breadcrumbIMG.css({
            'height': breadcrumbTextWrapper.height() + $('header').height() + 100
        })
    }
}

// SINGLE BLOG - OTHER BLOG FIELD
// ------------------------------------------------------------------
if ($('.other-blog-field').length) {
    let otherBlogIMG = $('.other-blog-field .container .wrapper .image-field')
    let otherBlogWrapper = $('.other-blog-field .container .wrapper')
    let remainWidth = (windowWidth - otherBlogWrapper.width()) / 2

    $(window).resize(function () {
        let windowWidthResize = window.innerWidth
        let otherBlogIMG = $('.other-blog-field .container .wrapper .image-field')
        let otherBlogWrapper = $('.other-blog-field .container .wrapper')
        let remainWidth = (windowWidthResize - otherBlogWrapper.width()) / 2

        if (windowWidthResize > 900) {
            otherBlogIMG.find('.image').css({
                'left': -remainWidth,
                'width': 'calc(100% + ' + remainWidth + 'px)',
            })
        } else {
            otherBlogIMG.find('.image').css({
                'left': 0,
                'width': '100%',
            })
        }
    })

    if (windowWidth > 900) {
        otherBlogIMG.find('.image').css({
            'left': -remainWidth,
            'width': 'calc(100% + ' + remainWidth + 'px)',
        })
    } else {
        otherBlogIMG.find('.image').css({
            'left': 0,
            'width': '100%',
        })
    }

    let blogItem = $('.blog-items .blog-item')
    let hoverTimeOut
    blogItem.hover(
        function () {
            blogItem.removeClass('active')
            $(this).addClass('active')
            let image = $(this).attr('data-image');
            if (otherBlogIMG.find('img').attr('src') == image) {

            } else {
                otherBlogIMG.find('.img').addClass('active')

                clearTimeout(hoverTimeOut)
                hoverTimeOut = setTimeout(() => {
                    otherBlogIMG.find('img').attr('src', image)

                    let loadedImage = document.createElement('img')
                    loadedImage.src = image

                    loadedImage.onload = function () {
                        otherBlogIMG.find('.img').removeClass('active')
                    }
                }, 450)
            }
        },
        function () {

        }
    )

}

// FOOTER
// ------------------------------------------------------------------
if ($('footer').length) {
    if (windowWidth <= 1200) {
        footer.css({
            'margin-bottom': $('.fixed-button').height()
        })
    }
    $(window).resize(function () {
        let windowWidthResize = window.innerWidth
        if (windowWidthResize <= 1200) {
            footer.css({
                'margin-bottom': $('.fixed-button').height()
            })
        }
    })
}

// SINGLE SOLUTION
// ------------------------------------------------------------------
if ($('.single-solution').length) {
    let singleSolutionIMG = $('.single-solution-field .container .wrapper .image-field')
    let singleSolutionWrapper = $('.single-solution-field .container .wrapper')
    let remainWidth = (windowWidth - singleSolutionWrapper.width()) / 2

    $(window).resize(function () {
        let windowWidthResize = window.innerWidth
        let singleSolutionIMG = $('.other-blog-field .container .wrapper .image-field')
        let singleSolutionWrapper = $('.other-blog-field .container .wrapper')
        let remainWidth = (windowWidthResize - singleSolutionWrapper.width()) / 2
        if (windowWidthResize > 900) {
            singleSolutionIMG.find('.image').css({
                'left': -remainWidth,
                'width': 'calc(100% + ' + remainWidth + 'px - 3px)',
            })
        } else {
            singleSolutionIMG.find('.image').css({
                'left': 0,
                'width': '100%',
            })
        }
    })
    if (windowWidth > 900) {
        singleSolutionIMG.find('.image').css({
            'left': -remainWidth,
            'width': 'calc(100% + ' + remainWidth + 'px - 3px)',
        })
    } else {
        singleSolutionIMG.find('.image').css({
            'left': 0,
            'width': '100%',
        })
    }
}

// FAQ MODULE
// ------------------------------------------------------------------
if ($('.faq-module').length) {
    let faqSelector = $('.faq-module .container .wrapper .faq-list li .inner-content')
    let faqOuterContentActive
    faqSelector.click(function () {
        faqOuterContentActive = $(this).closest('.active')
        if ($(this).hasClass('active')) {
            $(this).removeClass("active")
            $(this).find(".text-content").stop().slideUp(450)
        } else {
            faqSelector.removeClass("active")
            faqSelector.find(".text-content").stop().slideUp(450)
            $(this).addClass("active")
            $(this).find(".text-content").stop().slideDown(450)
        }
    })
}

// SUPPORT
// ------------------------------------------------------------------
if ($('.support-form-field').length) {
    let supportLI = $('.support-form-field .container .wrapper .image-field .image ul li')
    let supportBackgroundIMG = $('.support-form-field .container .wrapper .image-field .image .background-full-image')
    let supportLIIMG, hoverTimeOut, supportID, formContainerID

    let supportFormSelector = $('.support-form-field .container .wrapper .form-field .form-selector')
    supportFormSelector.height(supportFormSelector.find('.form-container.active').height())

    supportLI.hover(
        function () {

        },
        function () { }
    )
    supportLI.click(function () {
        // IMAGE CHANGE
        supportLI.removeClass('active')
        $(this).addClass('active')
        supportLIIMG = $(this).attr('data-image')
        supportBackgroundIMG.addClass('active')
        supportBackgroundIMG.find('.img').addClass('active')

        clearTimeout(hoverTimeOut)
        hoverTimeOut = setTimeout(() => {
            supportBackgroundIMG.find('img').attr('src', supportLIIMG)

            let loadedImage = document.createElement('img')
            loadedImage.src = supportLIIMG

            loadedImage.onload = function () { supportBackgroundIMG.find('.img').removeClass('active') }
        }, 10)

        // FORM CHANGE
        supportID = $(this).attr('data-id')
        supportFormSelector.find('.form-container').removeClass('active')
        $.each(supportFormSelector.find('.form-container'), function () {
            formContainerID = $(this).attr('data-id')
            if (formContainerID == supportID) {
                $(this).addClass('active')
                supportFormSelector.height($(this).height())
            }
        })
    })

}

// SINGLE PRODUCT
// ------------------------------------------------------------------
if ($('.single-product').length) {
    let productLI = $('.product-main-field .top-field .container .wrapper .right-field ul li')

    let contentSelector = $('.product-main-field .content-field .container .wrapper .content-selector')
    contentSelector.height(contentSelector.find('.content.active').height())

    let productTabID, contentID

    productLI.click(function () {
        productLI.removeClass('active')
        $(this).addClass('active')
        productTabID = $(this).attr('data-id')
        contentSelector.find('.content').removeClass('active')
        $.each(contentSelector.find('.content'), function () {
            contentID = $(this).attr('data-id')
            if (contentID == productTabID) {
                $(this).addClass('active')
                contentSelector.height($(this).height())
            }
        })
    })

}

// ABOUT
// ------------------------------------------------------------------
if ($('.about-text-field').length) {
    let aboutIMG = $('.about-text-field .container .wrapper .image-field')
    let aboutWrapper = $('.about-text-field .container .wrapper')
    let remainWidth = (windowWidth - aboutWrapper.width()) / 2
    $(window).resize(function () {
        let windowWidthResize = window.innerWidth
        let aboutIMG = $('.about-text-field .container .wrapper .image-field')
        let aboutWrapper = $('.about-text-field .container .wrapper')
        let remainWidth = (windowWidthResize - aboutWrapper.width()) / 2
        if (windowWidthResize > 900) {
            aboutIMG.find('.image').css({
                'left': -remainWidth,
                'width': 'calc(100% + ' + remainWidth + 'px - 3px)',
            })
        } else {
            aboutIMG.find('.image').css({
                'left': 0,
                'width': '100%',
            })
        }
    })
    if (windowWidth > 900) {
        aboutIMG.find('.image').css({
            'left': -remainWidth,
            'width': 'calc(100% + ' + remainWidth + 'px - 3px)',
        })
    } else {
        aboutIMG.find('.image').css({
            'left': 0,
            'width': '100%',
        })
    }
}

// APPEND ITEM (WORK PARTNER - REFERENCES)
// ------------------------------------------------------------------
if ($('.append-item').length) {
    $.each($('.append-item'), function () {
        let workPartnerImageField = $(this).find('.image-field')
        let workPartnerItem = $(this).find('.item')
        let workPartnerColumnCount, workPartnerRowCount
        workPartnerColumnCount = workPartnerImageField.css('grid-template-columns').split(' ').length
        workPartnerRowCount = workPartnerImageField.css('grid-template-rows').split(' ').length

        let $i
        let deger = (workPartnerRowCount * workPartnerColumnCount) - workPartnerItem.length

        for ($i = 0; $i < deger; $i++) {
            workPartnerImageField.append('<div class="item"></div>')
        }
    })
}

// WORK PARTNER - CIRCLE
// ------------------------------------------------------------------
if ($('.work-partner-field').length) {
    var workPartnerField = document.querySelector('.work-partner-field .container .wrapper .left-field .image-field');
    var workPartnerCircleSelector = document.querySelector('.work-partner-field .container .wrapper .left-field .image-field .circle');

    workPartnerField.onmouseover = function () {
        workPartnerCircleSelector.classList.add('active');
    };

    workPartnerField.onmouseleave = function () {
        workPartnerCircleSelector.classList.remove('active');
    };

    workPartnerField.onmousemove = function (e) {
        const rect = e.currentTarget.getBoundingClientRect();
        workPartnerCircleSelector.style.left = (e.clientX - rect.left) + 'px';
        workPartnerCircleSelector.style.top = (e.clientY - rect.top) + 'px';
    };
}

// WORK PARTNER - CIRCLE
// ------------------------------------------------------------------
if ($('.references-field').length) {
    var referencesField = document.querySelector('.references-field .container .wrapper .left-field .image-field');
    var referencesCircleSelector = document.querySelector('.references-field .container .wrapper .left-field .image-field .circle');

    referencesField.onmouseover = function () {
        referencesCircleSelector.classList.add('active');
    };

    referencesField.onmouseleave = function () {
        referencesCircleSelector.classList.remove('active');
    };

    referencesField.onmousemove = function (e) {
        const rect = e.currentTarget.getBoundingClientRect();
        referencesCircleSelector.style.left = (e.clientX - rect.left) + 'px';
        referencesCircleSelector.style.top = (e.clientY - rect.top) + 'px';
    };
}

// POPUP ORDER
// ------------------------------------------------------------------
if ($('.popup-order')) {
    let innerField = $('.popup-products .inner .content')
    let pdTopField = $('.popup-products .inner .content .top-field')
    let popupContent = $('.popup-products .inner .content .scrollbar')
    $.each(popupContent, function () {
        if (windowWidth > 768) {
            let remainHeight = $(this).closest('.content').height() - $(this).closest('.content').find('.top-field').height() - 50
            $(this).css('max-height', remainHeight)
        } else {
            let remainHeight = $(this).closest('.content').height() - $(this).closest('.content').find('.top-field').height()
            $(this).css('max-height', remainHeight)
        }
        $(window).resize(function () {
            let windowWidthResize = window.innerWidth
            if (windowWidthResize > 768) {
                let remainHeight = $(this).closest('.content').height() - $(this).closest('.content').find('.top-field').height() - 50
                $(this).css('max-height', remainHeight)
            } else {
                let remainHeight = $(this).closest('.content').height() - $(this).closest('.content').find('.top-field').height()
                $(this).css('max-height', remainHeight)
            }
        })
    })

    let popupPropertiesInnerField = $('.popup-products.properties .inner')
    let popupPropertiesTopField = $('.popup-products.properties .inner .content .top-field')
    let popupPropertiesContent = $('.popup-products.properties .inner .content .scrollbar')
    let popupProperitesRemainHeight = popupPropertiesInnerField.height() - popupPropertiesTopField.height() - 50
    popupPropertiesContent.css('max-height', popupProperitesRemainHeight)
    $(window).resize(function () {
        let popupProperitesRemainHeight = popupPropertiesInnerField.height() - popupPropertiesTopField.height() - 50
        popupPropertiesContent.css('max-height', popupProperitesRemainHeight)
    })

    let popupFormSelectorField = $('.popup-products.request .inner .content .form-field .form-selector-field')
    popupFormSelectorField.height(popupFormSelectorField.find('.form-selector.active').height())

    let popupFormTypeSelectorLI = $('.popup-products.request .inner .content .top-field .form-tab-field ul li')
    let popupFormTypeTextField = $('.popup-products.request .inner .content .top-field .editor')
    let popupFormTypeID, popupFormSelectorID, popupFormTypeText
    popupFormTypeSelectorLI.click(function () {
        popupFormTypeText = $(this).find('.text')
        popupFormTypeTextField.html('<h3><strong>' + popupFormTypeText.text() + '</strong></h3>')
        popupFormTypeSelectorLI.removeClass('active')
        $(this).addClass('active')
        popupFormTypeID = $(this).attr('data-id')
        popupFormSelectorField.find('.form-selector').removeClass('active')
        $.each(popupFormSelectorField.find('.form-selector'), function () {
            popupFormSelectorID = $(this).attr('data-id')
            if (popupFormSelectorID == popupFormTypeID) {
                $(this).addClass('active')
                popupFormSelectorField.height($(this).height())
            }
        })
    })

    let popupOffer = $('#popup-product-offer')
    let popupDriver = $('#popup-product-driver')
    let popupProperties = $('#popup-product-properties')
    let popupRequest = $('#popup-product-request')
    let closeButton = $('.popup-products .inner .content .top-field .close-button')

    $('.offer-open').on('click', function () {
        popupOffer.removeClass('popup-hidden')
        popupDriver.addClass('popup-hidden')
        popupProperties.addClass('popup-hidden-reverse')
        popupRequest.addClass('popup-hidden')
        $('.bg-overlay').addClass('active')
        $('header').addClass('hidden')
        $('body').addClass('overflow-hidden')
    })
    $('.driver-open').on('click', function () {
        popupOffer.addClass('popup-hidden')
        popupDriver.removeClass('popup-hidden')
        popupProperties.addClass('popup-hidden-reverse')
        popupRequest.addClass('popup-hidden')
        $('.bg-overlay').addClass('active')
        $('header').addClass('hidden')
        $('body').addClass('overflow-hidden')
    })
    $('.properties-open').on('click', function () {
        popupOffer.addClass('popup-hidden')
        popupDriver.addClass('popup-hidden')
        popupProperties.removeClass('popup-hidden-reverse')
        popupRequest.addClass('popup-hidden')
        $('.bg-overlay').addClass('active')
        $('header').addClass('hidden')
        $('body').addClass('overflow-hidden')
    })
    $('.request-open').on('click', function () {
        popupOffer.addClass('popup-hidden')
        popupDriver.addClass('popup-hidden')
        popupProperties.addClass('popup-hidden-reverse')
        popupRequest.removeClass('popup-hidden')
        $('.bg-overlay').addClass('active')
        $('header').addClass('hidden')
        $('body').addClass('overflow-hidden')
    })
    $('.bg-overlay').on('click', function () {
        popupOffer.addClass('popup-hidden')
        popupDriver.addClass('popup-hidden')
        popupProperties.addClass('popup-hidden-reverse')
        popupRequest.addClass('popup-hidden')
        $('.bg-overlay').removeClass('active')
        $('header').removeClass('hidden')
        $('body').removeClass('overflow-hidden')
    })
    closeButton.on('click', function () {
        popupOffer.addClass('popup-hidden')
        popupDriver.addClass('popup-hidden')
        popupProperties.addClass('popup-hidden-reverse')
        popupRequest.addClass('popup-hidden')
        $('.bg-overlay').removeClass('active')
        $('header').removeClass('hidden')
        $('body').removeClass('overflow-hidden')
    })
    if (windowWidth > 768) {
        $('.popup-products .inner .content').css({
            'padding-right': $('.popup-products .inner .right-field').width(),
            'max-width': 'calc(575px + ' + $('.popup-products .inner .right-field').width() + 'px)',
            'min-width': 'calc(575px + ' + $('.popup-products .inner .right-field').width() + 'px)',
        })
        $('.popup-products.properties .inner .content').css({
            'padding-right': 0,
            'padding-left': $('.popup-products .inner .right-field').width(),
            'max-width': 'calc(575px + ' + $('.popup-products .inner .right-field').width() + 'px)',
            'min-width': 'calc(575px + ' + $('.popup-products .inner .right-field').width() + 'px)',
        })
    }

    $('.form-file-upload').change(function () {
        var filename = $(this).val().replace(/C:\\fakepath\\/i, '')
        $(this).closest('.button-field').find('.file-name').text(filename)
    })
}

// HOMEPAGE - WHY FIELD
// ------------------------------------------------------------------
if ($('.homepage-why-field').length) {
    let homepageWhyIMG = $('.homepage-why-field .container .wrapper .inner-container')
    let homepageWhyWrapper = $('.homepage-why-field .container .wrapper')
    let remainWidth = ((windowWidth - homepageWhyIMG.width()) / 2) - 30

    $(window).resize(function () {
        let windowWidthResize = window.innerWidth
        let homepageWhyIMG = $('.homepage-why-field .container .wrapper .inner-container')
        let homepageWhyWrapper = $('.homepage-why-field .container .wrapper')
        let remainWidth = (windowWidthResize - homepageWhyIMG.width()) / 2

        if (windowWidthResize > 900) {
            homepageWhyIMG.find('.right-field').css({
                'right': 0,
                'width': 'calc(100% + ' + remainWidth + 'px)',
            })
            homepageWhyIMG.find('.right-field .content').css({
                'width': 'calc(100% - ' + remainWidth + 'px)',
            })
        } else {
            homepageWhyIMG.find('.right-field').css({
                'right': 0,
                'width': '100%',
            })
            homepageWhyIMG.find('.right-field .content').css({
                'width': '100%',
            })
        }
    })

    if (windowWidth > 900) {
        homepageWhyIMG.find('.right-field').css({
            'right': 0,
            'width': 'calc(100% + ' + remainWidth + 'px)',
        })
        homepageWhyIMG.find('.right-field .content').css({
            'width': 'calc(100% - ' + remainWidth + 'px)',
        })
    } else {
        homepageWhyIMG.find('.right-field').css({
            'right': 0,
            'width': '100%',
        })
        homepageWhyIMG.find('.right-field .content').css({
            'width': '100%',
        })
    }

    // CAROUSEL HEIGHT FIELD
    let whyLeftField = $('.homepage-why-field .container .wrapper .left-field')
    let whyRightField = $('.homepage-why-field .container .wrapper .right-field')
    if (windowWidth >= 600) {
        whyRightField.find('.homepage-product-carousel').height(whyLeftField.innerHeight() - 180)
    } else {
        whyRightField.find('.homepage-product-carousel').height(100)
    }
}

// YOUR PC - STEP 1
// ------------------------------------------------------------------
if ($('.your-pc.step-one').length) {
    let stepOneSelect = $('.your-pc-content--one .container .wrapper .carousel-field .your-pc-carousel .swiper-wrapper .swiper-slide .content .text-field ul li')
    stepOneSelect.click(function () {
        stepOneSelect.removeClass('active')
        $(this).addClass('active')
    })

    let stepOneSwiperSlide = $('.your-pc-content--one .container .wrapper .carousel-field .your-pc-carousel .swiper-wrapper .swiper-slide')
    let stepOneIMG = $('.your-pc-content--one .container .wrapper .image-field')
    let hoverTimeOut
    stepOneSwiperSlide.hover(
        function () {
            // IMAGE CHANGE
            let image = $(this).attr('data-image');
            stepOneIMG.find('.img').addClass('active')

            clearTimeout(hoverTimeOut)
            hoverTimeOut = setTimeout(() => {
                stepOneIMG.find('img').attr('src', image)

                let loadedImage = document.createElement('img')
                loadedImage.src = image

                loadedImage.onload = function () {
                    stepOneIMG.find('.img').removeClass('active')
                }
            }, 450)

            // TEXT FIELD HEIGHT
            $(this).find('.text-field').slideDown(450)
        },
        function () {
            $(this).find('.text-field').slideUp(450)
        }
    )
}

// YOUR PC - STEP 2
// ------------------------------------------------------------------
if ($('.your-pc.step-two').length) {
    // Tab Field
    let stepTwoSelector = $('.your-pc-content--two .container .wrapper .step-two-list li .inner-content .title-field')
    let stepTwoOuterContentActive
    stepTwoSelector.click(function () {
        stepTwoOuterContentActive = $(this).closest('.inner-content')
        if ($(this).closest('.inner-content').hasClass('active')) {
            $(this).closest('.inner-content').removeClass("active")
            $(this).closest('.inner-content').find(".text-content").stop().slideUp(450)
        } else {
            stepTwoSelector.closest('.inner-content').removeClass("active")
            stepTwoSelector.closest('.inner-content').find(".text-content").stop().slideUp(450)
            $(this).closest('.inner-content').addClass("active")
            $(this).closest('.inner-content').find(".text-content").stop().slideDown(450)
        }
    })
}

// PRODUCTS
// ------------------------------------------------------------------
if ($('.products').length) {
    $('.fixed-button').addClass('hide')
    $('.fixed-button-products').addClass('show')

    let titleField = $('.popup-products.properties .inner .content .form-field .form .title-field')
    let titleContentActive
    titleField.click(function () {
        titleContentActive = $(this).closest('.item')
        if ($(this).closest('.item').hasClass('active')) {
            $(this).closest('.item').removeClass("active")
            $(this).closest('.item').find(".field-content").stop().slideUp(450)
        } else {
            titleField.closest('.item').removeClass("active")
            titleField.closest('.item').find(".field-content").stop().slideUp(450)
            $(this).closest('.item').addClass("active")
            $(this).closest('.item').find(".field-content").stop().slideDown(450)
        }
    })
}

// HOMEPAGE - SLIDER FIELD
// ------------------------------------------------------------------
if ($('.homepage-slider-field').length) {
    let homepageSliderIMG = $('.homepage-slider-field .carousel-field .homepage-carousel .swiper-wrapper .swiper-slide .content .image-field .img')
    let fixedField = $('.fixed-button')
    if (windowWidth <= 1200) {
        homepageSliderIMG.css({
            'height': 'calc(100vh - ' + fixedField.height() + 'px)'
        })
    }
}



// INPUT UPGRADE / DOWNGRADE
// ------------------------------------------------------------------
if ($('.upgrade').length && $('.downgrade').length) {
    let inputIncrease = $('.upgrade');
    let inputDecrease = $('.downgrade');
    inputIncrease.click(function () {
        let input = $(this).closest('.count-box').find('input')
        let inputVal = input.val()
        let max = parseInt(input.attr('max'))

        if (inputVal < max) {
            inputVal++;
            input.val(inputVal)
        }
    })
    inputDecrease.click(function () {
        let input = $(this).closest('.count-box').find('input')
        let inputVal = input.val();
        let min = parseInt(input.attr('min'))

        if (inputVal > min) {
            inputVal--;
            input.val(inputVal);
        }
    })
}


// BLOG ITEMS
// ------------------------------------------------------------------
if ($('.homepage-blog-field').length) {
    let blogItems = $('.homepage-blog-field .blog-items .blog-item')
    let blogItemCount = blogItems.length - 2
    let blogIMG = $('.other-blog-field .container .wrapper .image-field .image')
    blogIMG.height(blogItems.innerHeight() * blogItemCount + 150 + 40)
}

// SAMPLE USAGE
// ------------------------------------------------------------------
// if ($('.sample').length) { }